<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
    <div class="card">
      <div class="card-body">
        <CRow>
          <CCol sm="5" lg="12" >
            
             <CRow >
              <CCol sm="5" lg="4" >
                 <label class="mt-2"  > Periode Join Member </label>  
               <b-form-select v-model="period" :options="options_periods"></b-form-select>
              </CCol>
              
              <CCol sm="5" lg="4" >
                <label class="mt-2"> Periode Covenant </label>
                 <b-form-select v-model="period_covenant" :options="options_periods_covenant"></b-form-select>
              </CCol>
              <CCol sm="5" lg="4" >
                <label class="mt-2" > Periode Volunteer </label>
              <b-form-select v-model="period_volunteer" :options="options_periods_volunteer"></b-form-select>
              </CCol>
            </CRow>
            <CRow  >
              <CCol sm="5" lg="4" > 
                 <CButton class="col-5 mt-3 " variant="outline" color="info" @click="filter()">Filter Report</CButton>
              </CCol>
              
            </CRow>
           
          </CCol>
        </CRow>
     
    </div>
    </div>
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="5" lg="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @search="handleSearch"
                            :btn_show="false"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <membermodal></membermodal>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import report from '@/services/report';
import member from '@/services/member';
import membermodal from './member_modal';

import newcomer from '@/services/newcomer';
import service from '@/services/service';
import keperluan from '@/services/keperluan';

import alertmodal from '@/views/alert/modal.vue';
import Multiselect from 'vue-multiselect'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, membermodal, alertmodal,Multiselect },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false},
          {key: 'dob', sortable: false},
          {key: 'mobile_phone', sortable: false},
          {key: 'address1', sortable: false},
          {key: 'created_at', sortable: false},
          {key: 'covenant_date', sortable: false},
          {key: 'volunteer_date', sortable: false},
      ],
      items: [],
      options_member:[],
      options_service:[],
      options_keperluan: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      options_periods: [],
      options_periods_covenant: [],
      options_periods_volunteer: [],
      getPeriods: [],
      getPeriodsCovenant: [],
      getPeriodsVolunteer: [],
      period: '',
      period_covenant: '',
      period_volunteer: ''
    }
   },
    created() {
  },

   mounted (){
     this.loadData()
     this.loadPeriod()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     loadData(p) {


      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        period: this.period,
        period_covenant: this.period_covenant,
        period_volunteer: this.period_volunteer
      }
      report.getMemberReport(params)
      .then(res => {
          //console.log(res.periods)
          let getData = res.data
          this.getPeriods = res.periods
          this.getPeriodsCovenant = res.periods_covenant
          this.getPeriodsVolunteer = res.periods_volunteer
              this.options_periods = []
              this.options_periods.push({text: '', value:''})
              for (let i=0; i <= this.getPeriods.length-1; i++){
                this.options_periods.push({text: this.getPeriods[i].monthYear, value:this.getPeriods[i].monthYear})
              }
              this.options_periods_covenant = []
              this.options_periods_covenant.push({text: '', value:''})
              for (let i=0; i <= this.getPeriodsCovenant.length-1; i++){
                this.options_periods_covenant.push({text: this.getPeriodsCovenant[i].monthYear, value:this.getPeriodsCovenant[i].monthYear})
              }
              this.options_periods_volunteer = []
              this.options_periods_volunteer.push({text: '', value:''})
              for (let i=0; i <= this.getPeriodsVolunteer.length-1; i++){
                this.options_periods_volunteer.push({text: this.getPeriodsVolunteer[i].monthYear, value:this.getPeriodsVolunteer[i].monthYear})
              }
          this.items = getData.data
          console.log(this.getPeriods)
          console.log(this.items)
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      //        console.log("asd")
      // console.log(this.getPeriods)
      // console.log("asd")
      // for (let i=0; i <= getPeriods.length-1; i++){
      //   //alert
      //   this.options_periods.push({text: getPeriods[i].monthYear, value:getPeriods[i].monthYear})
      //   console.log('test');
      // }




    },

    filter(){
      //console.log("filter")
      //console.log(this.getPeriods)
      //this.loadData("07-2019")
      this.loadData()
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleGrantWebAccess(val) {
      if(confirm("Do you really want to grant web access?")){
        member.grantwebaccess(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }   
    },
    handleResetPassword(val) {
      if(confirm("Do you really want to reset password?")){
        member.resetpassword(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }       
    },    

  }
  
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
